import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
@Component({
    selector: 'formly-repeat-section',
    template: `
      @if (props.label) {
        <label class="form-label">{{ props.label }}</label>
      }
      <!-- <p *ngIf="props.description">{{ props.description }}</p> -->
      
      @for (field of field.fieldGroup; track field; let i = $index; let last = $last; let first = $first) {
        <div class="row align-items-baseline">
          <formly-field class="col" [field]="field"></formly-field>
          @if (last) {
            <div class="col-2 d-flex align-items-center">
              @if (i!==0) {
                <button class="btn btn-sm btn-danger" type="button" (click)="remove(i)">-</button>
              }
              <button class="btn btn-sm btn-success" type="button" (click)="add()">+</button>
            </div>
          }
          @if (last) {
            <div class="col-1 d-flex align-items-center">
            </div>
          }
        </div>
      }
      `,
    standalone: false
})
export class FormlyRepeatSectionTypeComponent extends FieldArrayType {}
